export default "__VITE_ASSET__4854114e__"